







import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import WorkflowHostModal from './WorkflowHostModal';
import WorkflowMeasurementModal from './WorkflowMeasurementModal';
import WorkflowTriggerModal from './WorkflowTriggerModal'; // Importa el nuevo modal
import WorkflowContainer from './WorkflowContainer';
import ResourceItem from './ResourceItem';
import ModalAddHost from './ModalAddHost';
import ModalAddMedicion from '../TriggersAction/ModalAddMedicion';
import ModalAddTrigger from '../TriggersAction/ModalAddTrigger';
import ModalAddAction from '../TriggersAction/ModalAddAction';
import ModalAddNotificacion from '../TriggersAction/ModalAddNotificacion';
import ModalAddGroup from '../TriggersAction/ModalAddGroup';
import ModalAddDelay from '../TriggersAction/ModalAddDelay';
import Modal from "react-modal";
import '../WorkFlow.css'
import { lang } from '../../generales/traduction';
import { capitalizeFirstLetter } from '../../../utils/utils';


const steps = [
  { id: 'host', label: 'Host' },
  { id: 'measurement', label: 'Measurement' },
  { id: 'trigger', label: 'Trigger' },
  { id: 'event', label: 'Event' },
  { id: 'notification', label: 'Notification' },
];

const AddHosModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const AddMetricModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    height: "70%",
    padding: "20px",
  },
};
const AddDelayModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    height: "30%",
    padding: "20px",
  },
};
const WorkflowApp = ({server,languaje,mode,hosts,setDataWorkFlow,dataWorkFlow}) => {
  const resources = [
    { id: 'host', label: capitalizeFirstLetter(lang[languaje]['dispositivo']), type: 'entity' },
    { id: 'group', label: capitalizeFirstLetter(lang[languaje]['grupo']), type: 'entity' },
    { id: 'measurement', label: capitalizeFirstLetter(lang[languaje]['metrica']), type: 'measurement' },
    { id: 'trigger', label: capitalizeFirstLetter(lang[languaje]['disparador']), type: 'trigger' },
    
    { id: 'event', label: capitalizeFirstLetter(lang[languaje]['accion']), type: 'event' },
    // { id: 'delay', label: 'Delay', type: 'delay' },
    { id: 'delay', label: 'Intentos', type: 'delay' },
    { id: 'notification', label: capitalizeFirstLetter(lang[languaje]['notficacion']), type: 'notification' },
  ];
  const [enabledResources, setEnabledResources] = useState(['entity']);
  const [droppedItems, setDroppedItems] = useState([]);
  const [elementsList,SetElementList]=useState({
    host:'',
    measurement:'',
    trigger:'',
    event:'',
    delay:'',
    notification:'',
    group:''
  })
  const [selectedItem, setSelectedItem] = useState(null);
  const [selections, setSelections] = useState({});
  const [isHostModalOpen, setIsHostModalOpen] = useState(false);
  const [isMeasurementModalOpen, setIsMeasurementModalOpen] = useState(false);
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false); // Estado para abrir el Trigger Modal
  const [addHostModalOpen, setAddHostModalOpen] = useState(false);
  function closeAddHostModal() {
    setAddHostModalOpen(false);
  }
  const [addGroupModalOpen, setAddGroupModalOpen] = useState(false);
  function closeAddGroupModal() {
    setAddGroupModalOpen(false);
  }
  const [addMetricModalOpen, setAddMetricModalOpen] = useState(false);
  function closeAddMetricModal() {
    setAddMetricModalOpen(false);
  }
  const [addTriggeModalOpen, setAddTriggeModalOpen] = useState(false);
  function closeAddTriggeModal() {
    setAddTriggeModalOpen(false);
  }
  const [addEventModalOpen, setAddEventModalOpen] = useState(false);
  function closeAddEventModal() {
    setAddEventModalOpen(false);
  }
  const [addNotiModalOpen, setAddNotiModalOpen] = useState(false);
  function closeAddNotiModal() {
    setAddNotiModalOpen(false);
  }
  const [addDelayModalOpen, setAddDelayModalOpen] = useState(false);
  function closeAddDelayModal() {
    setAddDelayModalOpen(false);
  }
  const handleDrop = (item) => {
    let nextSteps = [];
    switch (item.type) {
      case 'entity':
        nextSteps = ['measurement'];
        // nextSteps = ['event'];
        if(item.id=="host"){
          setAddHostModalOpen(true);
        }else{
          setAddGroupModalOpen(true)
        }
        
        break;
      case 'measurement':
        nextSteps = ['trigger'];
        setAddMetricModalOpen(true);
        break;
      case 'trigger':
        nextSteps = ['event'];
        setAddTriggeModalOpen(true); // Abrir el Trigger Modal cuando se dropee un trigger
        break;
     
      case 'event':
        nextSteps = ['delay'];
        setAddEventModalOpen(true)
        break;
      case 'delay':
        nextSteps = ['notification'];
        setAddDelayModalOpen(true)
        break;
      case 'notification':
        setAddNotiModalOpen(true)
        break;
      default:
        nextSteps = [];
    }
    setEnabledResources(nextSteps);
    setDroppedItems((prevItems) => [...prevItems, item]);
  };

  const handleHostSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      host: selectedOption,
    }));
    setIsHostModalOpen(false);
  };

  const handleMeasurementSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      measurement: selectedOption,
    }));
    setIsMeasurementModalOpen(false);
  };

  const handleTriggerSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      trigger: selectedOption,
    }));
    setIsTriggerModalOpen(false);
  };

  const handleRemoveItem = (item) => {
    if (droppedItems[droppedItems.length - 1].id === item.id) {
      setDroppedItems((prevItems) => prevItems.slice(0, -1));
      const previousSelections = { ...selections };
      delete previousSelections[item.id];
      setSelections(previousSelections);
      setEnabledResources([item.type]);
    }
    SetElementList((prevState)=>{
      return {
          ...prevState,
        [item.id]:""
      }
      
  })
    if(item.type=='notification'){
      setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
          ['interested_user_group_ids']:[]
        }
        
    })
    setDataWorkFlow((prevState)=>{
      return {
          ...prevState,
        ['telegram_groups']:[]
      }
      
  })
    }
    else{
      
      if(item.id=='host'){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['hostid']:null
          }
          
      })
      }else if(item.id=='group'){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['groupid']:null
          }
          
      })
      }else if(item.id=='delay'){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['action_delay']:""
          }
          
      })
      }else{
        let attr=""
        if(item.type=='measurement'){
          attr="metric_id"
        }else if(item.type=='trigger'){
          attr='trigger_id'
        }else if(item.type='event'){
          attr='action_id'
        }
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            [attr]:0
          }
          
      })
      }
      
    }
  };

  const isLastItem = (item) => droppedItems.length > 0 && droppedItems[droppedItems.length - 1].id === item.id;

  const isStepCompleted = (stepId) => selections[stepId] !== undefined;

  const allStepsCompleted = steps.every((step) => isStepCompleted(step.id));

  return (
    <DndProvider backend={HTML5Backend}>
      <div className='contDragDrop'>
        <div className='contFields'>
          <div className='contFieldResourses'>
            <h3 className='titleResources'>{capitalizeFirstLetter(lang[languaje]['recursos'])}</h3>
            {resources.map((resource) => (
              <ResourceItem
                key={resource.id}
                resource={resource}
                isDisabled={!enabledResources.includes(resource.type)}
              />
            ))}
          </div>
          <div className='contFieldMap'>
            {/* <h3>Workflow</h3> */}
            <WorkflowContainer
              onDrop={handleDrop}
              acceptedTypes={enabledResources}
              droppedItems={droppedItems}
              onCardClick={setSelectedItem}
              onRemoveItem={handleRemoveItem}
              isLastItem={isLastItem}
              selections={selections}
              elementsList={elementsList}
            />
          </div>
        </div>

        {/* Tren de pasos */}
        {/* <div className='contSteps'>
          {steps.map((step) => (
            <div
              key={step.id}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                backgroundColor: isStepCompleted(step.id) ? '#e0ffe0' : '#f0f0f0',
                border: `2px solid ${isStepCompleted(step.id) ? '#2ecc71' : 'gray'}`,
                color: isStepCompleted(step.id) ? '#2ecc71' : 'gray',
                fontWeight: 'bold',
                textAlign: 'center',
                minWidth: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {step.label}
            </div>
          ))}
        </div> */}

        {/* Botón para crear flujo de trabajo */}
        {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button
            onClick={() => console.log("Creando flujo de trabajo...")}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: allStepsCompleted ? 'blue' : 'gray',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: allStepsCompleted ? 'pointer' : 'not-allowed',
            }}
            disabled={!allStepsCompleted}
          >
            Crear flujo de trabajo
          </button>
        </div> */}
        {/* ********Modal host********* */}
        <Modal
        isOpen={addHostModalOpen}
        onRequestClose={closeAddHostModal}
        style={AddHosModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddHost
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeAddHostModal={closeAddHostModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddHost>
    </Modal>
      {/* ********Modal Group********* */}
      <Modal
        isOpen={addGroupModalOpen}
        onRequestClose={closeAddGroupModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddGroup
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal ={closeAddGroupModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddGroup>
    </Modal>
    {/******************ModalAddMedicion*******************  */}
    <Modal
        isOpen={addMetricModalOpen}
        onRequestClose={closeAddMetricModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddMedicion
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddMetricModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddMedicion>
    </Modal>
 {/******************ModalAddTrigge*******************  */}
 <Modal
        isOpen={addTriggeModalOpen}
        onRequestClose={closeAddTriggeModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddTrigger
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddTriggeModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddTrigger>
    </Modal>

{/******************ModalAddAction*******************  */}
<Modal
        isOpen={addEventModalOpen}
        onRequestClose={closeAddEventModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddAction
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddEventModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddAction>
    </Modal>
    {/******************ModalAddDelay*******************  */}
<Modal
        isOpen={addDelayModalOpen}
        onRequestClose={closeAddDelayModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddDelay
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddDelayModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddDelay>
    </Modal>
{/******************ModalAddNoti*******************  */}
<Modal
        isOpen={addNotiModalOpen}
        onRequestClose={closeAddNotiModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddNotificacion
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddNotiModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddNotificacion>
    </Modal>










        {/* Modales */}
        <WorkflowHostModal
        server={server}
          isOpen={false}
          onRequestClose={() => {
            setIsHostModalOpen(false);
          }}
          onSelect={handleHostSelect}
        />

        <WorkflowMeasurementModal
          isOpen={isMeasurementModalOpen}
          onRequestClose={() => {
            setIsMeasurementModalOpen(false);
          }}
          onSelect={handleMeasurementSelect}
          hostId={selections.host?.id}
        />

        <WorkflowTriggerModal
          isOpen={isTriggerModalOpen}
          onRequestClose={() => {
            setIsTriggerModalOpen(false);
          }}
          onSelect={handleTriggerSelect}
          metricId={selections.measurement?.id} // Pasa el ID de la métrica seleccionada
        />
      </div>
    </DndProvider>
  );
};

export default WorkflowApp;
